import s from "../partnerPortal.module.css";
import { Panel, SectionTitle } from "./shared";

const STEPS = [
  {
    n: "1",
    t: "Create session",
    d: "Partner calls POST /v1/sessions with candidate name, email & role.",
    who: "Partner API",
  },
  {
    n: "2",
    t: "Session + credits",
    d: "Awasource creates a session, decrements credits, returns a hosted test URL.",
    who: "Awasource",
  },
  {
    n: "3",
    t: "Candidate tests",
    d: "Candidate opens the Awasource-hosted page — partner logo top, Powered by Awasource footer.",
    who: "Hosted page",
  },
  {
    n: "4",
    t: "Score & store",
    d: "Test is scored; result saved to a separate Awasource results database.",
    who: "Awasource",
  },
  {
    n: "5",
    t: "Deliver result",
    d: "Signed webhook to the partner; also queryable via API / portal if it fails.",
    who: "Webhook + fallback",
  },
];

const INFRA = [
  [
    "Separate public API + database",
    "The public API and its own database (awasource-public) are split from the internal private API; shares production infra initially, moves to a dedicated server as volume grows.",
  ],
  [
    "Login-only portal access",
    "No self-signup — partner credentials are issued manually once the deal is signed.",
  ],
  [
    "Signed, retried webhooks",
    "On completion, an HMAC-signed payload (session ID, questions, answers, analysis) is delivered with backoff retries and a results-query fallback.",
  ],
];

export default function Flow() {
  return (
    <div>
      <SectionTitle title="How it works" sub="The integration & candidate test flow" />

      <div className={s.pg44}
      >
        {STEPS?.map((step) => (
          <Panel className={s.pg45} key={step.n}>
            <div className={s.pg46}
            >
              {step.n}
            </div>
            <div className={s.pg47}
            >
              {step.who}
            </div>
            <div className={s.pg48}>
              {step.t}
            </div>
            <div className={s.pg49}>{step.d}</div>
          </Panel>
        ))}
      </div>

      <div className={s.grid2even}>
        <Panel>
          <div className={s.blockTitle}>Infrastructure</div>
          {INFRA?.map(([title, body]) => (
            <div className={s.pg50} key={title}>
              <span className={s.pg51}>◆</span>
              <div>
                <div className={s.pg52}>{title}</div>
                <div className={s.pg53}>{body}</div>
              </div>
            </div>
          ))}
        </Panel>

        <Panel sunken>
          <div className={s.blockTitle}>Candidate test page (white-label)</div>
          <div className={s.pg54}
          >
            <div className={s.pg55}
            >
              <div className={s.pg56}
              >
                IT
              </div>
              <span className={s.pg57}>ITM Africa</span>
            </div>
            <div className={s.pg58}>
              Business Analyst Assessment
            </div>
            <div className={s.pg59}>
              Question 4 of 30 · 12:40 remaining
            </div>
            <div className={`${s.trackThin} ${s.pg60}`}>
              <div className={s.pg61} />
            </div>
            <div className={s.pg62}
            >
              {["Option A", "Option B", "Option C"].map((option) => (
                <div className={s.pg63}
                  key={option}
                >
                  {option}
                </div>
              ))}
            </div>
            <div className={s.pg64}
            >
              Powered by <span className={s.pg65}>Awasource</span>
            </div>
          </div>
        </Panel>
      </div>
    </div>
  );
}
